import React from 'react'

import archihacks from '../img/logo/archihacks-logo.jpg'
import walletifai from '../img/logo/walletifai-logo.png'
import trulioo from '../img/logo/trulioo-logo.png'
import microsoft from '../img/logo/microsoft-logo.png'

import './Experience.css'

export default function Experience() {
  return (
    <section className="section featured-projects" data-sr-id="4">
      <div className="section-title">Experience</div>
      <div className="section-content">

        <div className="card">
          <div className="company">
            <img className="company-img" src={microsoft} />
            <div>
              <h1 className="company-name">Microsoft</h1>
              <h3 className="company-position">Software Engineer</h3>
            </div>
          </div>
          <div className="project-caption">
            <ul>
              <li>+ Led the development of Cashback mini app which started as an intern project into a production grade application on Microsoft Start and Bing app.</li>
              <li>+ Currently leading the development of mobile shopping experience under Content Services, implementing personalized coupons and cashback from manufacturers, CPGs and retailers that saves millions of dollars for end users each year.</li>
            </ul>
            <p className="toolbar">
              <div className="tool">React</div>
              <div className="tool">TypeScript</div>
              <div className="tool">C#</div>
              <div className="tool">.NET</div>
            </p>
          </div>
        </div>

        <div className="card">
          <div className="company">
            <img className="company-img" src={trulioo} />
            <div>
              <h1 className="company-name">Trulioo</h1>
              <h3 className="company-position">Junior Software Engineer</h3>
            </div>
          </div>
          <div className="project-caption">
            <ul>
              <li>
                + Extended existing identity verification microservice that provides an online form-builder for enterprise customers.
              </li>
              <li>
                + Established a new microservice that fit into the ecosystem using React frontend, Express backend, and various AWS services.
              </li>
            </ul>
            <p className="toolbar">
              <div className="tool">React</div>
              <div className="tool">TypeScript</div>
              <div className="tool">Nodejs</div>
              <div className="tool">C#</div>
              <div className="tool">.NET</div>
            </p>
          </div>
        </div>

        <div className="card">
          <div className="company" >
            <img className="company-img" src={walletifai} />
            <div>
              <h1 className="company-name">Walletifai</h1>
              <h3 className="company-position">Backend Developer Intern</h3>
            </div>
          </div>
          <div className="project-caption">
            <ul>
              <li>+ Implemented a client-facing API to receive user feedbacks for basic CRM.</li>
              <li>+ Wired up third party API's to facilitate internal services such as automated email.</li>
              <li>+ Addressed regular production bugs and improvements in existing services while using Kanban board to prioritize requirements and specifications.</li>
            </ul>
            <p className="toolbar">
              <div className="tool">Java</div>
              <div className="tool">Spring Boot</div>
              <div className="tool">REST API</div>
              <div className="tool">SQL</div>
            </p>
          </div>
        </div>

        <div className="card">
          <div className="company" >
            <img className="company-img" src={archihacks} />
            <div>
              <h1 className="company-name">Archi Hacks</h1>
              <h3 className="company-position">Software Developer</h3>
            </div>
          </div>
          <div className="project-caption">
            <ul>
              <li>+ A niche industry startup focusing on online education for young architects.</li>
              <li>+ Owned and executed Python plug-in projects for architectural software.</li>
              <li>+ Spearheaded design and production of new services in collaboration with multiple stakeholders, and delegated tasks to subordinate members.</li>
            </ul>
            <p className="toolbar">
              <div className="tool">Python</div>
              <div className="tool">Rhino Commons</div>
              <div className="tool">JavaScript</div>
              <div className="tool">three.js</div>
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}